$(document).ready(function() {
  $('#tabs li a:not(:first)').addClass('inactive');
  $('.tabs-container .container').hide();
  $('.tabs-container .container:first').show();

  $('#tabs li a').click(function(){
  var t = $(this).attr('id');

  if($(this).hasClass('inactive')){
    $('#tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');

    $('.tabs-container .container').hide();
    $('#'+ t + 'C').fadeIn('slow');
    }  
  });

  if(window.location.hash) {
    var tabID = window.location.hash.replace('-posts', '');
    $(tabID).click();
  }
});